import * as amplify from "../util/amplify.ts";
import ApiServer from "../ApiServer.ts";
import { EventStore } from "../server/EventStore.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import * as i18n from "../i18n.ts";

import { notadminmodal } from "../global_connected.ts";
import Icons from "../svg/Icons.ts";
import { clearTime } from "../lib/DateUtils.ts";


export async function calendarclean() {
  var TPL = await import("../calendar/modal_clean.mustache")

  var
    theModal = modal.openDomModal(TPL, {}),
    select = theModal.querySelector('select') as HTMLSelectElement,
    button = theModal.querySelector('button') as HTMLButtonElement;

  if (!FwDatas.getUser().isAdmin) {
    notadminmodal()
    button.disabled = true
    select.disabled = true

  } else {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      var
        endDate = new Date(),
        duration = parseInt(select.value),
        age = duration >= 12 ? i18n.get('duration.year', Math.round(duration / 12)) : i18n.get('duration.month', duration);
      endDate.setMonth(endDate.getMonth() - duration);
      endDate = clearTime(endDate)

      var
        ids = (await EventStore.getFor(["calendar/" + FwDatas.getFamily().family_id])).filter(evt => {
          if (!evt.rights.canDelete) {
            return false;
          }
          if (evt.endDate < endDate) {
            if (evt.recurrencyDescriptor.recurrency !== 'NONE') {
              if (evt.recurrencyDescriptor.recurrencyEndDate < endDate) {
                return true;
              } else {
                return false
              }
            }
            return true;
          }
        }).map(event => event.metaId),
        n = ids.length;
      if (ids.length === 0) {
        modal.simple({
          title: "eventclean.nodeletetitle",
          message: "eventclean.nodelete",
          lottie: "images/lottie/flying_saucer.json",
          button: "actions.gotit"
        })
      } else {
        if(!await modal.confirmDelete({
          title: "eventclean.confirmtitle",
          message: i18n.get("eventclean.confirmdescription", { age, n })
        })) return;


        ApiServer.metadelete(ids).then(() => {
          modal.closeDomModal(theModal)
          modal.toastDone('eventclean.toastdone',{ age, n })
        })
        amplify.publish('eventDeleted')

      }

    })
  }

}

function snackEventHardLimitReached(){
  modal.toast({
    text:'eventclean.hardsnack',
    onclick:modalEventHardLimitReached
  })
}
export function modalEventHardLimitReached(familyId = FwDatas.getFamily().metaId){
  if(familyId == FwDatas.getFamily().metaId){
    modal.ask({
      title:'eventclean.hardtitle',
      message:'eventclean.harddescription',
      svg:Icons.calendar.ic_calendar_limit,
      mediaSize:100,
      button:[
        {title:"eventclean.title",onclick:calendarclean},
        {title:"actions.later",class:"secondary"},
      ]
    })
  }else{
    modalOtherCircleEventHardLimitReached()
  }
}
export function modalOtherCircleEventHardLimitReached(){
  modal.ask({
    title:'eventclean.hardtitle',
    message:'eventclean.harddescriptionother',
    svg:Icons.calendar.ic_calendar_limit,
    mediaSize:100,
    button:[
      {title:"actions.gotit"},
    ]
  })
}

function snackEventSoftLimitReached(){
  modal.toast({
    text:'eventclean.softsnack',
    onclick:modalEventSoftLimitReached
  })
}
function modalEventSoftLimitReached(){
  modal.ask({
    title:'eventclean.softtitle',
    message:'eventclean.softdescription',
    svg:Icons.calendar.ic_calendar_limit,
    mediaSize:100,
    button:[
      {title:"eventclean.title",onclick:calendarclean},
      {title:"actions.later",class:"secondary"},
    ]
  })
}

export async function checkEventLimit(){
  var
    allMainEvent = await EventStore.getFor(['calendar/'+FwDatas.getFamily().family_id]),
    count = allMainEvent.length,
    limit = FwDatas.getState().premium.technicalLimitEvent;

  if(count>=limit){
    snackEventHardLimitReached()
  }else if(count>=0.8*limit){
    snackEventSoftLimitReached()
  }
}
export async function checkEventLimitOntry(familyId = FwDatas.getFamily().metaId,wannaAddCount=1){
  var
    calendarId = familyId.replace('family/','calendar/'),
    allMainEvent = await EventStore.getFor([calendarId]),
    count = allMainEvent.length,
    limit = FwDatas.getState().premium.technicalLimitEvent;

  if(count+wannaAddCount>limit){
    return false;
  }
  return true;
}